export default __webpack_public_path__ + "static/media/dougs_2.caca3464.png";